<template>
  <div class="content-builder">
    <div class="form-group">
      <label class="control-label" for="question_text">Question Text</label>
      <QuillEditor v-model:content="content.question.text" :contentType="'html'" :modules="editorModules"
                   :toolbar="toolbarOpts"
                   theme="snow"/>

    </div>
    <div class="form-group">
      <label class="control-label" for="question-text-classes">Question Text CSS Classes</label>
      <input id="question-text-classes" v-model="content.questionTextClasses" class="form-control" type="text">
    </div>
    <div class="form-group">
      <label class="control-label">Question Image</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <a class="btn btn-primary text-white" data-input="question-image" data-lfm="image">
            <i class="fa fa-image"></i>
          </a>
        </div>
        <input id="question-image" v-model="content.questionImage" class="form-control" type="text">
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" for="feedback_text">Feedback Instructional Text</label>
      <QuillEditor v-model:content="content.question.feedback" :contentType="'html'" :modules="editorModules"
                   :toolbar="toolbarOpts"
                   theme="snow"/>
    </div>


    <AnimationControlsComponent :content="content"></AnimationControlsComponent>

    <div class="form-group">
      <div class="actions">
        <div class="action-item">
          <button v-show="!limitReached" :disabled="limitReached" class="btn btn-default" type="button"
                  @click="addResponse"><i class="fa fa-plus"></i> Add Response
          </button>
          <small v-show="limitReached" class="text-muted">Questions are limited to a maximum of {{ limit }}
            responses.</small>
        </div>
        <div class="action-item">
          <div>
            <input id="multiselect" v-model="content.question.multiselect" class="mr-1" type="checkbox">
            <label class="control-label" for="multiselect">Multiple Select (with Submit)</label>
          </div>
          <div>
            <input id="comboscore" v-model="content.question.enableComboScores" :disabled="content.question.randomize"
                   class="mr-1" type="checkbox">
            <label class="control-label" for="comboscore">Enable Combo Scoring</label>
          </div>
          <div>
            <input id="aifeedback" v-model="content.question.enableAIFeedbackGeneration"
                   :disabled="!content.question.enableComboScores"
                   class="mr-1" type="checkbox">
            <label class="control-label" for="aifeedback">Enable AI Feedback Generation</label>
          </div>
        </div>
        <div class="action-item">
          <div>
            <input id="randomize" v-model="content.question.randomize" :disabled="content.question.enableComboScores"
                   class="mr-1" type="checkbox">
            <label class="control-label" for="randomize">Randomize Responses</label>
          </div>
          <div>
            <input id="show-0-val-outcomes" v-model="content.showOutcomeOfZero" class="mr-1" type="checkbox">
            <label class="control-label" for="show-0-val-outcomes">Show outcomes with value of 0</label>
          </div>
        </div>
        <div class="action-item">
          <div>
            <input id="skip-feedback" v-model="content.skipFeedback" class="mr-1" type="checkbox">
            <label class="control-label" for="skip-feedback">Skip Feedback</label>
          </div>
        </div>
      </div>

      <div :class="showComboScores ? 'combo-enabled' : ''" class="content-list">
        <div v-for="(response, index) in content.question.responses" v-cloak :key="index"
             class="card content-list-item">
          <div class="card-header text-center font-weight-bold">{{ alphabet[index] }}</div>
          <div class="card-body">

            <div class="choice-wrap mb-2">
              <div class="col pl-0 choice-input">
                <label class="control-label" for="label">Choice Text</label>
                <QuillEditor v-model:content="content.question.responses[index].label" :contentType="'html'"
                             :options="editorOpts"/>
              </div>
              <div class="col pr-0 feedback-input">
                <label class="control-label" for="label">Feedback</label>
                <QuillEditor v-model:content="content.question.responses[index].feedback" :contentType="'html'"
                             :options="editorOpts"/>
              </div>
            </div>

            <div v-show="!showComboScores" class="form-group row">
              <div class="col-sm-6">
                <label class="control-label" for="feedback-image">Feedback Image</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <a :data-input="'feedback-image-' + index" class="btn btn-primary text-white"
                       data-lfm="image">
                      <i class="fa fa-image-o"></i> Choose
                    </a>
                  </div>
                  <input :id="'feedback-image-' + index" v-model.lazy="response.image" class="form-control"
                         type="text">
                </div>
              </div>
              <div class="col-sm-3">
                <label class="control-label" for="flow">Flow Hook</label>
                <input v-model="response.flow" :placeholder="'choice-' + (index + 1)" class="form-control"
                       type="text">
              </div>
              <div class="col-sm-3">
                <label class="control-label" for="flow">Outcome Trigger</label>
                <input v-model="response.trigger" :placeholder="'event-' + (index + 1)" class="form-control"
                       type="text">
              </div>
            </div>

            <div class="form-group card-metrics">
              <div class="col-9 pl-0 meters">
                <label class="control-label" for="metrics">Meter Effects</label>
                <div class="meter-wrap">
                  <div v-for="meter in response.meters" :key="meter.id" class="col">
                    <span :class="['badge', 'badge-primary', meter.id]">{{ meter.id }}</span>
                    <input :id="meter.id" v-model="meter.value" class="form-control" type="number">
                  </div>
                </div>
              </div>
              <div class="col-3 pr-0 col-rmv">
                <button class="btn btn-danger btn-block btn-remove" type="button"
                        @click="remove(response, index)">Remove
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="content.question.responses.length > 0">
        <div class="action-item">
          <button v-show="!limitReached" :disabled="limitReached" class="btn btn-default" type="button"
                  @click="addResponse"><i class="fa fa-plus"></i> Add Response
          </button>
          <small v-show="limitReached" class="text-muted">Questions are limited to a maximum of {{ limit }}
            responses.</small>
        </div>
      </div>

      <template v-if="content.question.enableAIFeedbackGeneration">
        <assistant-selector :id="content.assistantId"
                            @handle-change="content.assistantId = $event"></assistant-selector>

        <div class="form-group">
          <label class="control-label">Feedback Generator Prompt</label>
          <textarea v-model="content.question.promptFeedbackAssistant" class="form-control"
                    style="height: 200px;"></textarea>
          <small class="form-text text-muted">Provide detailed instructions on how you'd like the
            AI to evaluate a user's input and provide textual feedback. This is also where you can set character limits
            for feedback (i.e. Please limit feedback to 500 characters or
            less).</small>
        </div>

        <!--        <div class="form-group mt-4">-->
        <!--          <label class="control-label">Scoring Assistant Prompt</label>-->
        <!--          <textarea v-model="content.question.promptScoringAssistant" class="form-control"-->
        <!--                    style="height: 200px;"></textarea>-->
        <!--          <small class="form-text text-muted">Provide detailed instructions on how you'd like the-->
        <!--            AI to evaluate a user's selections and assign each meter a score of poor, satisfactory, good, or-->
        <!--            excellent.</small>-->
        <!--        </div>-->

        <div class="form-group mb-4">
          <button class="btn btn-default" type="button" @click="autoGenerateFeedback()">
            <i class="fa fa-plus"></i> Auto Generate Feedback
          </button>
        </div>
      </template>

      <div v-show="showComboScores" class="pt-4">
        <combo-score-component v-for="(comboScore, index) in this.comboScores" v-cloak
                               :id="comboScore.id"
                               :key="index"
                               v-model:feedback="comboScore.feedback"
                               v-model:flow="comboScore.flow"
                               v-model:meters="comboScore.meters"
                               v-model:trigger="comboScore.trigger"
                               :combinations="comboScore.combinations"
                               :defaultComboOpts="defaultComboOpts"
                               :generateFeedback="comboScore.generateFeedback"
                               :index="index"
                               :showRegenerateButton="comboScore.showRegenerateButton"
                               v-on:patchcombosettings="patchComboSettings($event)"
                               v-on:patchmetervals="patchMeterValues($event)"
                               v-on:regeneratefeedback="handleRegenerate($event)"
                               v-on:removecombo="removeComboScore($event)">
        </combo-score-component>
        <button class="btn btn-default" type="button" @click="addComboScore()">
          <i class="fa fa-plus"></i> Add Combo Scoring Feedback
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {Echo} from '../../../common/socket'
import {v4 as uuid4} from 'uuid'
import {defaultMeters} from '../../../common/metrics'
import layoutMixin from '../../mixins/layout'
import limitedMixin from '../../mixins/limited'
import ComboScoreComponent from '../ComboScoreComponent.vue'
import AnimationControlsComponent from "../AnimationControlsComponent.vue"
import AssistantSelector from "../AssistantSelector.vue"
import {EDITOR_CONFIG_BUTTONS_FULL, EDITOR_CONFIG_LITE} from '../../../common/constants'
import {QuillEditor} from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

export default {
  components: {ComboScoreComponent, QuillEditor, AnimationControlsComponent, AssistantSelector},
  mixins: [layoutMixin, limitedMixin],
  data() {
    const content = _.cloneDeep(this.source)
    let filled = _.defaults(content, {
      question: {
        text: '',
        feedback: '',
        multiselect: false,
        timeLimit: false,
        responses: [],
        enableComboScores: false,
        enableAIFeedbackGeneration: false,
        comboScores: [this.defaultComboScore('default')],
        animationEffects: {
          responseDisplay: '',
          responseStartDelay: 0,
          responseBetweenDelay: 0.2
        },
        questionTextClasses: '',
        promptScoringAssistant: '',
        promptFeedbackAssistant: ''
      },
      stubs: [],
      assistantId: '',
      pusherChannelId: ''
    })

    if (filled.question.feedback === undefined) {
      filled.question.feedback = 'The outcome for the response you chose is highlighted. Tap the other choices to explore the other possible outcomes.'
    }

    // pre-fill with default data
    filled.question.responses.forEach((response) => {
      if (!response.meters || !response.meters.length) {
        response.meters = defaultMeters()
      }
    })

    if (!_.get(content, 'showOutcomeOfZero')) {
      content.showOutcomeOfZero = false;
    }

    if (!_.get(filled.question, 'comboScores') || filled.question.comboScores.length == 0) {
      filled.question.comboScores = [this.defaultComboScore('default')]
    }

    if (!_.get(filled.question, 'enableComboScores')) {
      filled.question.enableComboScores = false
    }

    if (!_.get(filled.question, 'enableAIScoring')) {
      filled.question.enableAIScoring = false
    }

    if (!_.get(filled.question, 'questionTextClasses')) {
      filled.question.questionTextClasses = ''
    }

    if (!_.get(filled.question, 'animationEffects')) {
      filled.question.animationEffects = {
        responseDisplay: '',
        responseStartDelay: 0,
        responseBetweenDelay: 0.2
      }
    }

    return {
      content: filled,
      limit: 20,
      toolbarOpts: EDITOR_CONFIG_BUTTONS_FULL,
      editorOpts: EDITOR_CONFIG_LITE
    }
  },
  computed: {
    limitedItem() {
      return this.content.question.responses
    },
    showComboScores() {
      if (this.content.question.enableComboScores) {
        this.content.question.randomize = false
      }
      return this.content.question.enableComboScores
    },
    comboScores() {
      return this.content.question.comboScores
    },
    defaultComboOpts() {
      let opts = []
      this.content.question.responses.forEach((response, index) => {
        opts.push({value: false})
      })
      return opts
    }
  },
  methods: {
    getValue() {
      _.each(this.content.question.responses, (response, key) => {
        this.content.question.responses[key].image = $("#feedback-image-" + key).val()
      })
      _.each(this.content.question.comboScores, (comboScore, key) => {
        comboScore.generateFeedback = false
        comboScore.showRegenerateButton = false
      })
      return this.content
    },
    defaultComboScore(id) {
      const defaultComboScore = {
        id: id,
        feedback: '',
        flow: null,
        trigger: null,
        meters: defaultMeters(),
        combinations: [this.defaultComboOpts]
      }
      return defaultComboScore
    },
    remove(item, index) {
      this.content.question.responses.splice(index, 1)
    },
    addResponse() {
      this.content.question.responses.push({
        meters: defaultMeters()
      })
    },
    addComboScore() {
      this.content.question.comboScores.push(this.defaultComboScore(uuid4()))
    },
    removeComboScore(index) {
      this.content.question.comboScores.splice(index, 1)
    },
    patchMeterValues($event) {
      try {
        let comboScore = this.content.question.comboScores.filter((cs) => {
          return cs.id == $event.id
        })[0]
        let meter = comboScore.meters.filter((meter) => {
          return meter.id == $event.meterId
        })[0]
        if (comboScore && meter) {
          meter.value = $event.value
        }
      } catch (e) {
        console.log(e)
        console.log('error trying to update meter values')
      }
    },
    patchComboSettings: function ($event) {
      let comboScore = this.content.question.comboScores.filter((cs) => {
        return cs.id == $event.id
      })[0]
      comboScore.combinations = $event.settings
    },
    autoGenerateFeedback: function () {
      this.content.pusherChannelId = uuid4()
      this.content.question.comboScores = []

      function generateCombinations(responses, initialCombination = []) {
        let result = []

        if (initialCombination.length > 0) {
          result.push(initialCombination)
        }

        let start = responses.indexOf(initialCombination[initialCombination.length - 1]) + 1

        for (let i = start; i < responses.length; i++) {
          let newCombination = initialCombination.concat(responses[i])
          result = result.concat(generateCombinations(responses, newCombination))
        }

        return result
      }

      let responsesByLetter = this.content.question.responses.map((response, index) => {
        return index
      })

      let allCombinations = generateCombinations(responsesByLetter)

      this.$nextTick(() => {

        allCombinations.forEach(async (combination, index) => {
          let stub = this.defaultComboScore(uuid4())

          // clone stub
          stub = JSON.parse(JSON.stringify(stub))

          let responses = []

          combination.forEach((responseIndex) => {
            stub.combinations[0][responseIndex].value = true
            responses.push(this.content.question.responses[responseIndex].label)
            stub.responses = responses.join(',')
          })
          stub.generateFeedback = true
          stub.showRegenerateButton = true
          this.content.question.comboScores.push(stub)
          this.content.stubs.push(stub)
          await this.postGenerateFeedback(index, stub)
        })
      })
      const channelPrefix = document.head.querySelector('meta[name="broadcast-channel-prefix"]')
      Echo.channel(`${channelPrefix.content}.page.${this.content.pusherChannelId}`)
          .listen('GenerateFeedback', (e) => {
            console.log('Feedback generated')
            this.content.question.comboScores[parseInt(e.feedbackIndex)].feedback = e.feedback
          })
    },
    handleRegenerate: async function (index) {
      let stub = this.content.stubs[index]
      await this.postGenerateFeedback(index, stub)
    },
    postGenerateFeedback: async function (index, stub) {
      let resp = await window.axios.post(`//${window.location.hostname}/job/generate-feedback`, {
        data: {
          id: stub.id,
          index: index,
          pusherChannelId: this.content.pusherChannelId,
          assistantId: this.content.assistantId,
          feedbackPrompt: this.content.question.promptFeedbackAssistant,
          responses: stub.responses
        }
      })
      return resp
    }
  }
}
</script>

<style lang="scss">
.choice-wrap .ql-container {
  height: auto !important;
  margin-bottom: 1rem;
}

.content-list {
  clear: both;

  .form-group {

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.choice-wrap,
.meter-wrap {
  display: flex;

  .col:first-of-type {
    padding-left: 0;
  }
}

.card-metrics {
  align-items: flex-end;
  display: flex;
}

.actions {
  align-items: flex-start;
}

.combo-enabled {
  .choice-input {
    padding-right: 0;
  }

  .meters,
  .feedback-input {
    display: none;
  }

  .col-rmv {
    padding-left: 0;
  }

  .btn-remove {
    max-width: 200px;
  }
}
</style>
